import { H7 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import { MARIGOLD_DARK } from 'HubStyleTokens/colors';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RerunTestAlert = ({
  onClick,
  onResetTest,
  loading
}) => {
  return /*#__PURE__*/_jsxs(UIAlert, {
    className: "m-bottom-2",
    type: "warning",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex-row align-center",
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-1",
        name: "warning",
        color: MARIGOLD_DARK,
        size: "small"
      }), /*#__PURE__*/_jsx(H7, {
        className: "m-y-0 p-y-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "debuggerPanel.step.rerunTest.title"
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "m-y-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "debuggerPanel.step.rerunTest.body"
      })
    }), /*#__PURE__*/_jsx(UILoadingButton, {
      loading: loading,
      size: "small",
      use: "primary",
      onClick: onClick,
      onLoadingFinish: onResetTest,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "debuggerPanel.step.rerunTest.button"
      })
    })]
  });
};
export default RerunTestAlert;